module.exports = __webpack_public_path__ + "static/media/multiplier-icon.6cce89d1.png";